/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerBankAccountDto } from './CustomerBankAccountDto';
export type AcceptRenewalTermsDto = {
    /**
     * Selected payment frequency. WEEKLY is not allowed.
     */
    paymentFrequency: AcceptRenewalTermsDto.paymentFrequency;
    /**
     * Annual payment method. Only BANK_TRANSFER is allowed on this path.
     */
    annualPaymentMethod?: AcceptRenewalTermsDto.annualPaymentMethod;
    /**
     * Payment start date for instalment plans (date-only string)
     */
    paymentDate?: string;
    /**
     * Premium funding quote UUID for instalment plans
     */
    premiumFundingQuoteId?: string;
    /**
     * Bank account details for fortnightly/monthly instalments
     */
    customerBankAccount?: CustomerBankAccountDto;
};
export namespace AcceptRenewalTermsDto {
    /**
     * Selected payment frequency. WEEKLY is not allowed.
     */
    export enum paymentFrequency {
        ANNUAL = 'ANNUAL',
        MONTHLY = 'MONTHLY',
        FORTNIGHTLY = 'FORTNIGHTLY',
    }
    /**
     * Annual payment method. Only BANK_TRANSFER is allowed on this path.
     */
    export enum annualPaymentMethod {
        BANK_TRANSFER = 'BANK_TRANSFER',
    }
}

